import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import LoadingWheel from '@argos/loading-wheel'

import { Creators as FormsCreators } from '../../actions'

import Freeform from './Freeform/Freeform'

// Post Chat Components
import FeedbackTextArea from './FeedbackTextArea/FeedbackTextArea'
import FeedbackMultipleChoice from './FeedbackMultipleChoice/FeedbackMultipleChoice'

import Slider from './Slider/Slider'

import config from '../../../Core/Config'

export class Form extends React.Component {
  static propTypes = {
    currentQuestion: PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.string,
      text: PropTypes.string,
      pageValue: PropTypes.string,
      regex: PropTypes.shape({
        pattern: PropTypes.string,
        description: PropTypes.string,
        flags: PropTypes.string,
      }),
    }),
    hasValidationError: PropTypes.bool,
    inputValue: PropTypes.string.isRequired,
    isLastQuestion: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onValidationError: PropTypes.func.isRequired,
    stage: PropTypes.string,
  }

  handleSubmit = (input) => {
    const {
      onValidationError,
      onSubmit,
      currentQuestion: { regex: { pattern, flags } = {} },
    } = this.props

    if (pattern) {
      const regex = new RegExp(pattern, flags)
      if (!regex.test(input.value)) {
        return onValidationError()
      }
    }
    return onSubmit(input)
  }

  render() {
    const { currentQuestion, inputValue, hasValidationError, onChange, stage, isLastQuestion } = this.props

    if (!currentQuestion) {
      return (
        <div className='lc-controls__form lc-controls__form--with-seperator'>
          <LoadingWheel contained noMask />
        </div>
      )
    }

    const { id, type, title, regex, options, pageValue, text, minValue, maxValue } = currentQuestion

    const scale = [minValue, maxValue]

    const buttonText = isLastQuestion ? 'Submit' : 'Next Question'

    const freeFormProps = {
      buttonText,
      hasError: hasValidationError,
      id,
      label: title,
      onChange,
      onSubmit: this.handleSubmit,
      question: text,
      regex,
      trackingCode: pageValue,
      value: inputValue,
    }

    const multiChoiceProps = {
      id,
      question: text,
      options,
      onSubmit: this.handleSubmit,
    }

    const sliderProps = {
      question: text,
      id,
      trackingCode: options ? options[0].pageValue : '',
      buttonText,
      scale,
      onChange,
      onSubmit: this.handleSubmit,
      showTooltip: false,
    }

    const FreeFormComponent = stage === config.stages.POST_CHAT ? FeedbackTextArea : Freeform
    const MultiChoiceComponent = stage === config.stages.POST_CHAT && FeedbackMultipleChoice

    return (
      <React.Fragment>
        {type === 'FREEFORM' && <FreeFormComponent {...freeFormProps} />}
        {type === 'SINGLE_OPTION' && stage === config.stages.POST_CHAT && (
          <MultiChoiceComponent {...multiChoiceProps} />
        )}
        {type === 'MULTICHOICE' && stage === config.stages.POST_CHAT && <MultiChoiceComponent {...multiChoiceProps} />}
        {type === 'SCALE' && <Slider {...sliderProps} />}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  currentQuestion: state.Forms.currentQuestion,
  hasValidationError: state.Forms.hasValidationError,
  inputValue: state.Forms.inputValue,
  isLastQuestion: state.Forms.isLastQuestion,
  stage: state.Chat.stage,
})

const mapDispatchToProps = (dispatch) => ({
  onChange: (input) => dispatch(FormsCreators.updateInputField(input)),
  onSubmit: (answer) => dispatch(FormsCreators.submitAnswer(answer)),
  onValidationError: () => dispatch(FormsCreators.setValidationError()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form)
